<!-- Button trigger modal -->
<button type="button" class="btn btn-primary borwser-btn" data-toggle="modal" data-target="#browsersupport">
  broswer support
</button>

<!-- Modal -->
<div class="modal fade" id="browsersupport" tabindex="-1" role="dialog" aria-labelledby="browsersupport" aria-hidden="true">
  <div class="modal-cover">
    <div class="browser-support-wrap">
      <div class="browser-support-inner">
        <div class="col-sm-12">
          <div class="browser-support-title"><strong>ATTENTION</strong></div>
          <div class="browser-support-info">The browser you are currently using is not yet supported withh the MindBerry platform. Please install one of the following browsers via the links below to continue.</div>
          <div class="browser-support-sec">
            <div class="col-sm-6 col-xs-6">
              <div class="browser-title">Firefox</div>
              <div class="browser-icon"><img src="/images/browser-icon-ff.png" /></div>
              <div class="browser-icon-btn"><a target="_blank" href="https://www.mozilla.org/en-GB/firefox/?v=a&utm_source=www.mozilla.org&utm_medium=download_button&utm_campaign=firefox_page&utm_content=downloader_email_form_experiment_va">View Site</a></div>
            </div>
            <div class="col-sm-66 col-xs-6">
              <div class="browser-title">Google Chrome</div>
              <div class="browser-icon"><img src="/images/browser-icon-gc.png" /></div>
              <div class="browser-icon-btn"><a target="_blank" href="https://www.google.com/chrome/">View Site</a></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</div>
